import React from "react"
import PropTypes from "prop-types"
import PopupModal from "components/Common/PopupModel"
import { formatToLocalTime, formatToLocalDate } from "helpers/date_helper"

const OfferStateHistoryModal = ({
  isOpen,
  toggle,
  historyData = [],
  isLoading = false,
}) => {
  const formatDateTime = (dateTimeString) => {
    return {
      time: formatToLocalTime(dateTimeString),
      date: formatToLocalDate(dateTimeString)
    }
  }

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="d-flex justify-content-center align-items-center py-5">
          <div className="spinner-border text-primary" role="status">
          </div>
        </div>
      )
    }

    if (historyData.length > 0) {
      return (
        <div className="timeline-container" style={{ maxHeight: '400px', overflowY: 'auto', padding: '20px' }}>
          {historyData.map((item, index) => {
            const { time, date } = formatDateTime(item.dateTime)
            return (
              <div key={index} className="timeline-item d-flex position-relative" style={{ marginBottom: '20px' }}>
                <div 
                  className="timeline-line position-absolute" 
                  style={{
                    left: '100px',
                    top: '0px',
                    width: '0.5px',
                    height: '100%',
                    backgroundColor: '#dee2e6',
                    zIndex: 1
                  }}
                ></div>
                
                {/* Time section */}
                <div className="timeline-time text-end" style={{ minWidth: '100px', paddingRight: '12px' }}>
                  <div className="fw-bold text-dark" style={{ fontSize: '0.8rem' }}>{time}</div>
                  <div className="text-muted" style={{ fontSize: '0.7rem' }}>{date}</div>
                </div>
                
                {/* Content section */}
                <div className="timeline-content flex-grow-1" style={{ paddingLeft: '12px' }}>
                  <div className="mb-1">
                    <h6 className="mb-0 fw-bold text-dark" style={{ fontSize: '0.9rem' }}>
                      State Change: From {item.initialState} → To {item.finalState}
                    </h6>
                  </div>
                  {item.comments && (
                    <p className="text-muted mb-0" style={{ fontSize: '0.8rem', lineHeight: '1.4' }}>
                      {item.comments}
                    </p>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      )
    }

    return (
      <div className="text-center py-5">
        <div className="avatar-md mx-auto mb-4">
          <div className="avatar-title bg-primary-subtle text-primary rounded-circle font-size-20">
            <i className="mdi mdi-history"></i>
          </div>
        </div>
        <h5 className="font-size-15">No History Found</h5>
      </div>
    )
  }

  return (
    <PopupModal
      isOpen={isOpen}
      toggle={toggle}
      title="Offer State History"
      size="lg"
    >
      {renderContent()}
    </PopupModal>
  )
}

OfferStateHistoryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  historyData: PropTypes.arrayOf(
    PropTypes.shape({
      initialState: PropTypes.string,
      finalState: PropTypes.string,
      dateTime: PropTypes.string,
      comments: PropTypes.string,
    })
  ),
  isLoading: PropTypes.bool,
}

export default OfferStateHistoryModal